// Tag constants for Bebop unions (must match proto/mythos.bop)

export const ClientMessageTag = {
  Subscribe: 1,
  Unsubscribe: 2,
  Chat: 3,
  AuthUser: 4,
  AuthAnonymous: 5,
} as const;

export const ServerMessageTag = {
  ObjectUpdateMessage: 1,
  ChatNotification: 2,
  LobbyListNotification: 3,
  AuthSuccess: 4,
  AuthError: 5,
  ToastNotification: 6,
} as const;
